import { useQuery } from '@tanstack/react-query'
import { getProcessCountries } from '@/api/processes-api'
import { toProcessEcommerceScope } from './process-ecommerce-scope'

export const useProcessCountries = (ecommerceIds?: string[]) => {
  return useQuery({
    queryKey: ['process-countries', ecommerceIds],
    queryFn: async ({ signal }) => {
      const response = await getProcessCountries(
        {
          pbFindProcessCountriesRequest: toProcessEcommerceScope(ecommerceIds)
        },
        signal
      )
      return response.countries ?? []
    },
    staleTime: Infinity
  })
}
